import { DynamicPropertyType } from 'types/DynamicPropertyType';

import { makeCSVImportError } from '../tree';
import type DynamicGroup from './Group';
import { DynamicProperty } from './Property';

export default class Color extends DynamicProperty<string> {
  type = DynamicPropertyType.COLOR;
  value = '#FFFFFF';

  constructor(parent: DynamicGroup, name: string, value: string) {
    super(parent, name, value);
    // this.becomeObservable();
  }

  setDefault = () => {
    this.setInitialValue('#FFFFFF');
  };

  setUsingCSV = (value: string) => {
    if (!CSS.supports('color', value)) {
      throw makeCSVImportError(this, `Invalid color: ${JSON.stringify(value)}`);
    }
    this.set(value);
  };
}
